import React from 'react'
import { InnerHeader } from '../../Components/inner-header/InnerHeader1'
import { Innerfooter } from '../../Components/inner-footer/Innerfooter1'
import { DashboardToSectionDetails } from '../../Components/CommanPages/DashboardToSectionDetails'
import { useLocation, useNavigate } from 'react-router-dom'
import { new_client_signupAPI, staff_add_client, staff_get_countries, staff_new_client_signup, staff_search_customer_list, staff_search_customer_list_new_API } from '../../../Static_Services/Staff_Services'
import { useState } from 'react'
import { useEffect } from 'react'
import { errorAlert, successAlert } from '../../../Static_Services/Alertmsg'
import { Col, Container, Modal, Row } from 'react-bootstrap'
import { StaffCardCarousel } from '../../Components/CommanPages/StaffCardCarousel'
import { InputField } from '../../../sharedComponents/InputField'
import { ClientBox } from '../../../sharedComponents/ClientBox'
import { SharedButton } from '../../../sharedComponents/Button'
import Swal from 'sweetalert2'
// import logo from "../../../../Images/logo_white_web.png";
import logo from "../../../Images/logo_white_web.png";
import { ClinetSelect } from '../../../sharedComponents/ClinetSelect'
import { StaffClientSelect } from './StaffClientSelect'
import moment from 'moment'

export const StaffClientSearchNew = () => {
    const business_id = localStorage.getItem('bzid');
    const location = useLocation();
    const [respData, setRespData] = useState([]);
    const navigate = useNavigate();
    const [serValue, setSerValue] = useState();
    const [modeChange, setModeChange] = useState(true);
    const [countryList, setCountryList] = useState();
    const [passModal, setPassModal] = useState(false);
    const [purchasedPassData, setPurchasedPassData] = useState([]);
    const [checkedPassId, setCheckedPassId] = useState();
    const [customerdata, setCustomerdata] = useState();

    const userDetail = JSON.parse(localStorage.getItem("userDetail"));

    const [classID, setClassID] = useState();
    const [myscheduled_date, setMyscheduled_date] = useState();
    const [clData, setClData] = useState([]);
    const [ctList, setCtList] = useState([]);
    const [searchedKeyword, setSearchedKeyword] = useState();
    const [selectedUser, setSelectedUser] = useState();

    const [passList, setPassList] = useState([]);
    const [passRadio, setPassRadio] = useState();

    const [isAddClientVisible, setIsAddClientVisible] = useState(false);
    const [selectedParent, setSelectedParent] = useState();

    useEffect(() => {
        if (location && location.state && location.state.schedule_id) {
            localStorage.setItem("sch_id", location.state.schedule_id);
        }
        if (location && location.state && location.state.back === 'pre') {
            setClassID(localStorage.getItem('cid'));
            setMyscheduled_date(localStorage.getItem('scheduled_date'));
            // localStorage.setItem("cid", location.state.class_id);
            if (location.state.serchKey) {
                searchHandler(location.state.serchKey);
                setSearchedKeyword(location.state.serchKey);
            }

        } else if (location && location.state && location.state.encodeClassId) {
            localStorage.removeItem('scheduled_date');
            localStorage.removeItem('cid');
            localStorage.setItem('scheduled_date', location.state.scheduled_date);
            setMyscheduled_date(location.state.scheduled_date)
            localStorage.setItem("cid", location.state.class_id);
            setClassID(location.state.encodeClassId);
        }
    }, [location])

    const getCuontry = async () => {
        const resp = await staff_get_countries();
        if (resp) {
            setCountryList(resp.data.data);
        }
    }

    useEffect(() => {
        getCuontry();
    }, [])



    const [error, setError] = useState({
        name: "",
        lastname: "",
        email: "",
        country_code: "",
        mobile: ""
    });

    const changeHandler = (e) => {
        const { name } = e.target;
        setError((pre) => ({
            ...pre,
            [name]: ""
        }));
    }

    const searchChange = (e) => {
        // const value = e.target.value;
        // setSerValue(value);
        // getDetails(value);
    }




    const submiteHandler = async (e) => {
        e.preventDefault();
        let isValid = 1;
        const fData = new FormData(e.target);
        const fValue = Object.fromEntries(fData.entries());
        const name = fValue.name;
        const lastname = fValue.lastname;
        const email = fValue.email;
        const country_code = fValue.country_code;
        const mobile = fValue.mobile;
        const refername = userDetail.name + ' ' + userDetail.lastname;


        // Regular expressions for email and phone number validation
        const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
        const phoneRegex = /^\d{10}$/; // Adjust this regex for your specific phone number format

        if (!name) {
            setError((pre) => ({ ...pre, name: "First Name is required" }));
            isValid = 0;
        }
        if (!lastname) {
            setError((pre) => ({ ...pre, lastname: "Last Name is required" }));
            isValid = 0;
        }
        if (!email) {
            setError((pre) => ({ ...pre, email: "Email is required" }));
            isValid = 0;
        } else if (!emailRegex.test(email)) {
            setError((pre) => ({ ...pre, email: "Invalid email format" }));
            isValid = 0;
        }
        if (!country_code) {
            setError((pre) => ({ ...pre, country_code: "Country Code is required" }));
            isValid = 0;
        }
        if (!mobile) {
            setError((pre) => ({ ...pre, mobile: "Phone is required" }));
            isValid = 0;
        } else if (!phoneRegex.test(mobile)) {
            setError((pre) => ({ ...pre, mobile: "Invalid phone number format" }));
            isValid = 0;
        }

        if (isValid === 1) {
            var detail = {
                name: name,
                lastname: lastname,
                email: email,
                country_code: country_code,
                mobile: mobile,
                discount: '',
                referred_by: refername,
            };
            const resp = await staff_add_client(detail);
            if (resp) {
                e.target.reset();
                successAlert(resp.data.message);
            }
        }
    };


    const classSignup = (items) => {
        if (items.my_passes_details.length != 0) {
            const Customerdata = items;
            setCustomerdata(Customerdata);
            const PurchasePassData = items.my_passes_details;
            setPurchasedPassData(PurchasePassData);
            const firstData = items.my_passes_details;
            const PassID = firstData[0].pass_id;
            setCheckedPassId(PassID);
            setPassModal(true);
        } else {
            errorAlert('Please purchase the pass');
            items.pass_buy = true;
            setRespData((pre) => {
                const prev = [...pre];
                return prev;
            });
        }
    }

    const getPassId = (event) => {
        const PsID = event.target.id;
        setCheckedPassId(PsID);
    }

    //  New Code

    const clientPasses = (data, value, parentData = "", type = "") => {
        let Waiver = 0;
        let client_id = "";
        if (type && type === 'family') {
            Waiver = parentData?.data?.waiver;
            client_id = parentData?.data?.client_id;
        } else {
            Waiver = value?.data?.waiver;
            client_id = value?.data?.client_id;
        }
        if (data && data.length != 0) {
            const filterCard = [];
            for (let i = 0; i < data.length; i++) {
                const element = data[i];
                if (element.valid_class_id && element.valid_class_id.length !== 0) {
                    for (let j = 0; j < element.valid_class_id.length; j++) {
                        const ee = element.valid_class_id[j];
                        if (ee === classID) {
                            filterCard.push(element);
                            break; // exit the inner loop
                        }
                    }
                }
            }
            if (filterCard && filterCard.length === 1) {
                let myIDS = '';
                if (value.myid) {
                    setSelectedUser(value.myid);
                    myIDS = value.myid;
                } else {
                    setSelectedUser(value.data.id);
                    myIDS = value.data.id;
                }
                const idsssss = filterCard[0].pass_id;
                signupClient(idsssss, myIDS);
            } else if (filterCard && filterCard.length > 1) {
                setPassList(filterCard);
                if (value.myid) {
                    setSelectedUser(value.myid);
                } else {
                    setSelectedUser(value.data.id);
                }
                setPassModal(true);
            }
        }
    };


    const searchHandler = async (data) => {
        const serchKey = data.replace(/\s+/g, '');
        const fData = {
            'pageid': "1",
            'business_id': business_id,
            'class_id': localStorage.getItem("cid"),
            'search_val': serchKey,
            'scheduled_date': myscheduled_date,
        };
        const resp = await staff_search_customer_list_new_API(fData);
        if (resp?.data?.status === 1) {
            const list = [];
            resp.data.data.map((e) => {
                list.push({
                    data: e,
                    profile_img: e.profile_img,
                    name: e.name,
                    gender: e.gender,
                    email: e.email,
                    my_passes_details: e.my_passes_details,
                    family_member: e.family_member
                });
            });

            setClData(list);
        } else {
            setClData([])
        };
    };


    const radioHandler = (data) => {
        setSelectedParent(data);
    }


    const classSignupWithpassId = async (items) => {
        const fData = {
            "user_id": items.id,
            "business_id": localStorage.getItem('bzid'),
            "class_id": location.state.class_id,
            "schedule_id": location.state.id,
            "instractor_id": userDetail.id,
            "pass_id": checkedPassId
        }
        const resp = await staff_new_client_signup(fData);
        if (resp) {
            successAlert(resp.data.message);
        }
    }

    const signupClient = async (id = '', UserId = '') => {
        let getpass_ids = '';
        let getuserID = '';
        if (id) { getpass_ids = id; } else { getpass_ids = passRadio; }
        if (UserId) { getuserID = UserId } else { getuserID = selectedUser }
        if (getpass_ids) {
            const detail = {
                'user_id': getuserID,
                'business_id': localStorage.getItem('bzid'),
                'class_id': location.state.class_id,
                'schedule_id': location.state.id,
                'pass_id': getpass_ids,
                'instractor_id': userDetail.id,
            };
            const resp = await new_client_signupAPI(detail);
            if (resp) {
                Swal.fire({
                    html: `<img src=${logo} class="img-fluid d-block mx-auto mt-5" alt='' />
              <h4 class="title text-capitalize text-center mt-4 textWhite">
              Success
            </h4>
            <p class="text-center my-4 textcolor">
            <small class="textWhite">
          ${resp.data.message}
            </small></p>
            `,
                    showClass: {
                        popup: 'custom-dialog-container',
                    },
                    customClass: {
                        confirmButton: 'custom-button custom-button-size modalbtn',
                    },
                }).then((result) => {
                    if (result.isConfirmed) {
                        navigate('/ClassSchedule');
                    }
                })
            }
        }
    }

    const searchChangeHandler = (data) => {
        if (data == '') { setClData([]); }
        setSelectedParent();
        setSearchedKeyword(data);
        searchHandler(data);
    }

    const passRadioHandler = (e) => {
        const { name, value } = e.target;
        setPassRadio(value);
    }

    return (
        <>
            <InnerHeader />
            <div className="body-grey">
                <section className="client-search-section">
                    <div className="RightSide mb-5">
                        {/* <div className="innerContent"> */}
                        <Container>
                            <Row className="pt-5" >
                                <Col className='col-md-12 bg-white pt-5 pb-5' style={{ borderRadius: '10px' }}>
                                    <Row>
                                        {modeChange ? (
                                            <>
                                                <Col className='col-md-6' onClick={() => setIsAddClientVisible(false)}>
                                                    <InputField
                                                        type="search"
                                                        placeholder="Search"
                                                        value={searchedKeyword}
                                                        onChange={(e) => searchChangeHandler(e.target.value)}
                                                        ownClass={'mb-1'}
                                                    />
                                                    {!selectedParent && clData && (
                                                        <div className="SearchClientPanel" id="SearchPanelBox">
                                                            <ClientBox data={clData} onClick={clientPasses} radioHandler={radioHandler} stateData={location.state} searchedKeyword={searchedKeyword} classID={classID} />
                                                        </div>
                                                    )}
                                                </Col>
                                                <Col className='col-md-2'>
                                                    <SharedButton
                                                        variant="Primary"
                                                        className="btn btn-primary"
                                                        type="button"
                                                        title="Add Client"
                                                        onClick={() => { setModeChange(false); }}
                                                    />
                                                </Col>
                                            </>
                                        )
                                            : (
                                                <>
                                                    <Col className='col-md-10'>
                                                    </Col>
                                                    <Col className='col-md-2'>
                                                        <SharedButton
                                                            variant="Primary"
                                                            className="btn btn-danger px-5 py-2"
                                                            type="button"
                                                            title="Cancel"
                                                            onClick={() => { setModeChange(true); }}
                                                        />
                                                    </Col>
                                                </>
                                            )
                                        }
                                    </Row>
                                </Col>
                            </Row>




                            {/* <div className="row">
                                                    <div className="col-11"></div>
                                                    <div className="col-1">
                                                        <button className="btn btn-green" onClick={resetHandler}>Reset</button>
                                                        <button type="button" id="passselect" data-backdrop="static" data-keyboard="false"
                                                            data-toggle="modal" data-target="#PassSelectModal" style={{ display: "none" }} ></button>
                                                    </div>
                                                </div> */}


                            {modeChange && selectedParent &&
                                <StaffClientSelect data={selectedParent} onClick={clientPasses} radioHandler={radioHandler} stateData={location.state} searchedKeyword={searchedKeyword} classID={classID} />
                            }

                            {modeChange && respData.length != 0 &&
                                <div className="tab-content bg-white border-radius6 p-3 mt-4" id="myTabContent">
                                    <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                                        <div class="row">
                                            {respData.map((items) => (
                                                <div class="col-lg-4 py-3 ">
                                                    <div class="activity-card box-shadow1 border-radius6 white-bg p-2">
                                                        <div class="client-slot-box d-flex " >
                                                            <div class="client-img">
                                                                <img src={items.profile_img} class="img-fluid" />
                                                            </div>
                                                            <div class="row client-detail pl-3">
                                                                <div class="col-12">
                                                                    <p class="black-color font-14 font-w-600 mb-0 d-flex">
                                                                        <span class="nametitle d-block">{items.name} {items.lastname}</span> </p>
                                                                    <span class="brand-color3 font-w-500 mt-2 d-block">{items.email}</span>
                                                                    <span class="brand-color3 font-w-500 mt-2 d-block">{items.country_code} {items.mobile}</span>
                                                                    {!items.pass_buy && <button onClick={() => classSignup(items)} class="btn btn-blue mt-2">Sign Up</button>}
                                                                    {items.pass_buy && <button onClick={() => { navigate('/customer-detail', { state: { client_id: items.id, stateData: location.state } }); }} class="btn btn-blue mt-2">Purchase</button>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div >

                            }
                            {clData.length === 0 &&
                                <div class="row tab-content bg-white border-radius6 p-3 mt-4">
                                    <div class="col-5"></div>
                                    <div class="col-2">
                                        <p class="font-awesome black-color font-18 d-inline mx-2"> No Client Available</p>
                                    </div>
                                    <div class="col-5"></div>
                                </div>
                            }
                            {!modeChange &&
                                <div className="tab-content bg-white border-radius6 p-3 mt-4" id="myTabContent">
                                    <div className="add-newclient">
                                        <form onSubmit={submiteHandler} autoComplete='off'>
                                            <div className="row">
                                                <div className="col-md-6 form-group py-3">
                                                    <label>First Name</label>
                                                    <input type="text" className="form-control-1 w-100" placeholder="Carl" name="name" onChange={changeHandler} />
                                                    <small className='text-danger'>{error.name}</small>
                                                </div>
                                                <div className="col-md-6 form-group py-3">
                                                    <label>Last Name</label>
                                                    <input type="text" className="form-control-1 w-100" placeholder="Oilver" name="lastname" onChange={changeHandler} />
                                                    <small className='text-danger'>{error.lastname}</small>
                                                </div>
                                                <div className="col-md-6 form-group py-3">
                                                    <label>Email</label>
                                                    <input type="email" className="form-control-1 w-100" placeholder="" name="email" onChange={changeHandler} />
                                                    <small className='text-danger'>{error.lastname}</small>
                                                </div>
                                                <div className="col-md-6 form-group py-3">
                                                    <label>Country Code</label>
                                                    <select className="form-control-1 w-100" name="country_code" onChange={changeHandler} >
                                                        {countryList && countryList.map((code, i) => (
                                                            <option key={i} selected={i === 0} value={`${code.code}`}>{`${code.name} (${code.code})`} </option>
                                                        ))}
                                                    </select>
                                                    <small className='text-danger'>{error.country_code}</small>
                                                </div>
                                                <div className="col-md-6 form-group py-3">
                                                    <label>Phone</label>
                                                    <input type="number" className="form-control-1 w-100 " placeholder="" name="mobile" onChange={changeHandler} />
                                                    <small className='text-danger'>{error.mobile}</small>
                                                </div>
                                            </div>
                                            <div className="d-flex justify-content-center">
                                                <button className="btn btn-green-grad text-capitalize d-block " type="submit">Add Client</button></div>
                                        </form>
                                    </div>
                                </div>
                            }
                        </Container>

                        {/* </div> */}
                    </div >
                    <Innerfooter />
                </section >

            </div >




            {/* <!-- Pass Select modal popup --> */}
            <Modal show={passModal} className="modal fade statusUpdate-modal modalwidth">
                <div
                    className="modal-dialog modal-dialog-centered "
                    role="document"
                >
                    <div className="modal-content ">
                        <div className="modal-body p-4">
                            <h5 className="title mb-4">
                                Purchased Passes List
                            </h5>
                            <div className="pb-5 change-yourstatus">
                                {passList.length > 0 &&
                                    passList.map((pass) => (
                                        <div
                                            className="prelist-pass p-3 blueback-pass mb-2"
                                            key={pass.pass_id}
                                        >
                                            <div className="mx-0 row align-items-center purchasepassList">
                                                <div className="col-lg-6">
                                                    <div className="passnew_logo">
                                                        <img
                                                            src={logo}
                                                            alt="Pass Logo"
                                                            className="img-fluid"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="row">
                                                        <div className="col-lg-10">
                                                            <div className="passdetail_new text-center flex-fill">
                                                                <p className="mb-0 text-capitalize">
                                                                    {pass.pass_name}
                                                                </p>
                                                                <h6 className="mb-2">
                                                                    $ {pass.full_price}{" "}
                                                                    <small>Plus Tax</small>
                                                                </h6>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-2">
                                                            <input
                                                                style={{ borderRadius: '10px', background: passRadio === pass.pass_id ? '#0075ff' : '' }}
                                                                type="radio"
                                                                name="pass_radio"
                                                                id={pass.pass_id}
                                                                className="pass_input_checkbox form-control"
                                                                value={pass.pass_id}
                                                                checked={passRadio === pass.pass_id}
                                                                onChange={passRadioHandler}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mt-4">
                                                <div className="col-12">
                                                    <p>
                                                        {pass.pass_type_category === "PunchCard" ? (
                                                            <span>
                                                                Remaining Classes: {`${pass.remaining_count ? pass.remaining_count + ' of ' : 'N/A'}`}
                                                                {`${pass.total_count ? pass.total_count : ''}`}
                                                            </span>
                                                        ) : (
                                                            <span>
                                                                Remaining Days: {`${pass.remaining_count ? pass.remaining_count + ' of ' : 'N/A'}`}
                                                                {`${pass.total_count ? pass.total_count : ''}`}
                                                            </span>
                                                        )}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="row mt-1 align-items-end">
                                                <div className="col-12">
                                                    <p className="font-12">
                                                        Purchase Date: {moment.unix(pass.start_date_utc).format('D MMM YYYY')}
                                                    </p>
                                                </div>
                                            </div>
                                            {/* <div className="row mt-1 align-items-end">
                                      <div className="col-12">
                                        <p className="font-12">
                                          Renewal Date:{" "}
                                          {pass.end_date_first_date}
                                        </p>
                                      </div>
                                    </div> */}

                                            <div className="row mt-1 align-items-end">
                                                <div className="col-12">
                                                    <p className="font-12">
                                                        {/* Expiration Date: {moment.unix(pass.pass_expired_date).format('MMMM D, YYYY')} */}
                                                        {["33", "34", "35", "36"].includes(pass.pass_type_subcat) ? (

                                                            `Renewal Date : ${pass.end_date}`

                                                        ) : (
                                                            ` Expiration Date:${pass.end_date}`
                                                        )}
                                                        {["33", "34", "35", "36"].includes(pass.pass_type_subcat) && (
                                                            <p> Expiration Date: {moment.unix(pass.pass_expired_date).format('MMMM D, YYYY')}</p>
                                                        )}

                                                        {["33"].includes(pass.pass_type_subcat) && (<p> Valid for 90 Days</p>)}
                                                        {["34"].includes(pass.pass_type_subcat) && (<p> Valid for 180 Days</p>)}
                                                        {["35"].includes(pass.pass_type_subcat) && (<p> Valid for 360 Days</p>)}

                                                    </p>
                                                </div>
                                            </div>
                                            <div className="row mt-1 align-items-end">
                                                <div className="col-12">
                                                    <p className="font-12" style={{ textTransform: 'capitalize' }}>
                                                        Status: {pass.card_status}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                            </div>
                            <SharedButton
                                type="button"
                                title={"Submit"}
                                data-dismiss="modal"
                                className="btn btn-brandblue text-capitalize w-100 mt-3"
                                onClick={() => signupClient()}
                            // disabled={staffSpinner}
                            />
                            <SharedButton
                                type="button"
                                data-dismiss="modal"
                                id="btn_close1"
                                onClick={() => setPassModal(false)}
                                className="btn btn-brandblue text-capitalize w-100 mt-3"
                                data-backdrop="static"
                                data-keyboard="false"
                                variant="primary"
                                title={"Close"}
                            />

                        </div>
                        <div></div>
                    </div>
                </div>
            </Modal >

            {/* <!-- END OF Pass Select modal popup --> */}
        </>
    )
}
